import { Checkbox, Accordion, AccordionGroup } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  assigneeTypeTitleCss,
  classlistContainerCss,
  accordionCss,
  noStudentsMessageCss,
  sgaCheckboxStyles,
  sgaClasslistItemCss,
} from "../../assignments/AssignmentEditor/AssigneeSelectorModal/AssigneeSelectorModal.style";

const propTypes = {
  classroomChoices: PropTypes.array,
  stagedStudentAssigneeSelection: PropTypes.array,
  setStagedStudentAssigneeSelection: PropTypes.func,
  setStagedClassroomSelection: PropTypes.func,
};

/**
 * StudentSelection displays a list of students, and allows
 * the list to be modified via checkboxes. A callback must
 * be provided to update the previouslySelectedStudents array prop.
 */
const StudentSelection = ({
  classroomChoices,
  stagedStudentAssigneeSelection,
  setStagedStudentAssigneeSelection,
  setStagedClassroomSelection,
}) => {
  const manageCheckboxClick = (studentChoice) => {
    const isChecked = stagedStudentAssigneeSelection.find(
      (stagedStudent) => stagedStudent.unique_id === studentChoice.unique_id,
    );
    if (isChecked) {
      const filteredStagedStudentSelection =
        stagedStudentAssigneeSelection.filter((currentlySelected) => {
          return currentlySelected.unique_id !== studentChoice.unique_id;
        });
      setStagedStudentAssigneeSelection([...filteredStagedStudentSelection]);
    } else {
      const formattedStudentChoice = {
        first_name: studentChoice.user.first_name,
        last_name: studentChoice.user.last_name,
        unique_id: studentChoice.unique_id,
      };
      setStagedClassroomSelection([]);
      setStagedStudentAssigneeSelection((prevStagedStudentsArray) => [
        ...prevStagedStudentsArray,
        formattedStudentChoice,
      ]);
    }
  };

  const renderNoStudentsMessage = () => {
    return (
      <div>
        <p css={noStudentsMessageCss}>This class doesn't have any students.</p>
      </div>
    );
  };

  return (
    <>
      <h3 css={assigneeTypeTitleCss}>Choose 1 or more students:</h3>
      <AccordionGroup>
        {classroomChoices?.map((classroom) => {
          return (
            <Accordion
              __cssFor={{
                root: accordionCss,
              }}
              key={classroom.unique_id}
              title={classroom.name}
            >
              {classroom.students?.length > 0 ? (
                <ul css={classlistContainerCss}>
                  {classroom.students?.map((studentChoice) => {
                    const isChecked = !!stagedStudentAssigneeSelection?.find(
                      (selectedStudent) => {
                        return (
                          selectedStudent.unique_id === studentChoice.unique_id
                        );
                      },
                    );
                    return (
                      <li
                        key={studentChoice.unique_id}
                        css={sgaClasslistItemCss}
                      >
                        <Checkbox
                          __cssFor={{
                            root: sgaCheckboxStyles,
                          }}
                          checked={isChecked}
                          withContainer
                          label={
                            studentChoice.user.first_name +
                            " " +
                            studentChoice.user.last_name
                          }
                          name="student"
                          value={
                            studentChoice.user.first_name +
                            " " +
                            studentChoice.user.last_name
                          }
                          onClick={() => manageCheckboxClick(studentChoice)}
                        />
                      </li>
                    );
                  })}
                </ul>
              ) : (
                renderNoStudentsMessage()
              )}
            </Accordion>
          );
        })}
      </AccordionGroup>
    </>
  );
};

StudentSelection.propTypes = propTypes;

export default StudentSelection;
